import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectCoverflow,
  Scrollbar,
  Autoplay,
} from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import bluelogo from "../images/EM-LOGO_Blue.png";
import "../CSS/awareness.css";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import ExitIntentPopup from "../Components/ExitIntentPopup";
import axios from "axios";
import { createTestRide } from "../Actions/testrideAction";
import ReactGAA from "react-ga4";
import { useDispatch } from "react-redux";

const KidsAwarenessScreen = () => {
  const specs = [
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Removable+Battery.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Removable+Battery+Mobile.jpg",
      title: "Removable Battery",
      desc: "Ride with confidence; we’ve got your back!",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Advanced+Mechanical+Disc+Brakes.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Advanced+Mechanical+Disc+Brakes+Mobile.jpg",
      title: "Advanced Mechanical Disc Brakes",
      desc: "Stop on a dime, every time!",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Smooth+Suspension.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Smooth+Suspension+Mobile.jpg",
      title: "Smooth Suspension",
      desc: "Glide over bumps like they don’t exist",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/LED+Lights+%26+Indicators.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/LED+Lights+%26+Indicators+Mobile.jpg",
      title: "LED Lights & Indicators",
      desc: "See and be seen, day or night",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/5+Riding+Modes.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/5+Riding+Modes+Mobile.jpg",
      title: "5 Riding Modes",
      desc: "Mechanical, Throttle, PAS, Cruise & Walk Mode",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Integrated+Display.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Integrated+Display+Mobile.jpg",
      title: "Integrated Display",
      desc: "All the info you want at a glance",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Sturdy%2C+Lightweight+Frame.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Sturdy%2C+Lightweight+Frame+Mobile.jpg",
      title: "Sturdy, Lightweight Frame",
      desc: "Strong enough for adventure, light enough for fun.",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Powerful+Motor.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Powerful+Motor+Mobile.jpg",
      title: "Powerful Motor",
      desc: "More vroom, less effort—just pure fun!",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Adjustable+Seat.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Adjustable+Seat+Mobile.jpg",
      title: "Adjustable Seat",
      desc: "Because kids grow, and so should their ride!",
    },
  ];
  const celebs = [
    {
      name: "Nitin Gadkari",
      designation: "Minister of Road & Transport Highways",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/Screenshot+2023-10-05+115126.png",
    },
    {
      name: "Shantanu Mukherjee",
      designation: "Playback Singer",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/wdwww.png",
    },
    {
      name: "Jayant Sinha",
      designation: "Member of Indian Parliament",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/Screenshot+2023-10-05+115119.png",
    },
    {
      name: "Terence Lewis",
      designation: "Coreographer",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/Screenshot+2023-10-05+134322.png",
    },
    {
      name: "Sunil Sheity",
      designation: "Indian Actor",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/WhatsApp+Image+2023-10-03+at+13.11.png",
    },
    {
      name: "Sonali Bendre",
      designation: "Indian Actress",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/fwfwff.png",
    },
    {
      name: "Aman Gupta",
      designation: "Co-founder of Boat Lifestyle",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/011+1.png",
    },
    {
      name: "Isha Koppikar",
      designation: "Indian Actress",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/wffwFF.png",
    },
    {
      name: "Baichung Bhutia",
      designation: "Indian Former Footballer",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/WhatsApp+Image+2023-10-05+at+12.44.png",
    },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  SwiperCore.use([
    Navigation,
    Pagination,
    EffectCoverflow,
    Scrollbar,
    Autoplay,
  ]);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [utmCampaign, setUtmCampaign] = useState("");
  const [gclid, setGclid] = useState("");

  const analyticEvent = (category, action) => {
    ReactGAA.event({
      category: category,
      action: action,
    });
  };

  useEffect(() => {
    // Fetching UTM campaign parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const campaign = urlParams.get("utm_campaign"); // Get the 'utm_campaign' parameter
    const GClid = urlParams.get("gclid");
    // Set the campaign name in the state
    if (campaign) {
      setUtmCampaign(campaign);
    }
    if (GClid) {
      setGclid(GClid);
    }
  }, []);

  useEffect(() => {
    const fetchIPAddress = async () => {
      try {
        const response = await axios.get("https://api64.ipify.org?format=json");
        if (response) {
          const clientIp = response.data.ip;
          const ipDataResponse = await axios.get(
            `https://ipapi.co/${clientIp}/json/`
          );

          setCity(ipDataResponse.data.city);
          setCountry(ipDataResponse.data.country);
          setZip(ipDataResponse.data.postal);
        }
      } catch (error) {
        console.error("Error fetching client IP:", error);
      }
    };

    fetchIPAddress();
  }, []);

  const bookTestride = async (event) => {
    try {
      event.preventDefault();
      const pageVisited = "Parents-Kids New Landing Page";

      const response = await dispatch(
        createTestRide(
          name,
          phoneNumber,
          city,
          country,
          zip,
          utmCampaign,
          gclid,
          pageVisited
        )
      );

      analyticEvent("Testride", "Testride Submitted Successfully");
      // navigate(`/testride-scheduled?id=${response}`);
      navigate(`/details-submitted`);
    } catch (error) {
      analyticEvent("Testride", "Testride Submission Failed");
      console.error("Error booking test ride:", error);
    }
  };
  return (
    <>
      <ExitIntentPopup />
      <div id="KidsAwarenessScreen">
        <div className="w-100 logo-bar">
          <div className=" desktop-nav m-0 p-0 p-3 ps-lg-5 pe-lg-5 ">
            <div className="d-flex justify-content-center ">
              <img
                src={bluelogo}
                className="img-fluid"
                style={{ width: "170px" }}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="position-relative">
          <picture className="main-banner-img">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Banners/Mobile+banner_.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Banners/Web+banner_.jpg"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Banners/Web+banner_.jpg"
              alt="Banner1"
              className="d-block w-100"
            />
          </picture>
          <div className="position-absolute bg-white p-4 rounded-3 d-none d-lg-block form-desktop">
            <h2
              className="mb-2 text-center"
              style={{ fontFamily: "Metropolis-bold", fontSize: "1.7em" }}
            >
              <em>
                <span style={{ color: "#004dac" }}>BOOK A FREE TEST RIDE</span>
              </em>
            </h2>
            <div
              className="mx-auto mb-3"
              style={{ height: "1px", backgroundColor: "black", width: "100%" }}
            ></div>
            <div>
              <p
                className="mt-3 text-center"
                style={{
                  fontFamily: "Metropolis-light",
                  fontSize: "0.9rem",
                  lineHeight: "1.3em",
                }}
              >
                <em>Experience the thrill of electric cycling!</em>
              </p>
            </div>
            <form
              className="d-flex mt-4 rounded-3 justify-content-between align-content-center flex-column"
              onSubmit={bookTestride}
            >
              <input
                type="text"
                className="form-control text-dark w-100 mb-3 "
                required
                value={name}
                autoComplete="off"
                style={{ background: "none" }}
                placeholder="Name"
                pattern="[A-Za-z\s]{2,}"
                onChange={(e) => {
                  setName(e.target.value);
                  e.target.setCustomValidity("");
                }}
                onInvalid={(e) =>
                  e.target.setCustomValidity(
                    "Name should have at least 2 characters and contain only alphabets."
                  )
                }
              />
              <input
                type="number"
                className="form-control text-dark w-100 mb-3"
                required
                value={phoneNumber}
                onChange={(e) => {
                  const phoneNumber = e.target.value.slice(0, 12);
                  setPhoneNumber(phoneNumber);

                  if (/^[6-9]\d{9}$/.test(phoneNumber)) {
                    e.target.setCustomValidity("");
                  } else {
                    e.target.setCustomValidity(
                      "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                    );
                  }
                }}
                onInvalid={(e) =>
                  e.target.setCustomValidity(
                    "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                  )
                }
                placeholder="Phone Number"
              />
              <div
                className="mb-2 text-muted text-center"
                style={{ fontSize: "0.7em" }}
              >
                <small>
                  Disclaimer: By sharing your contact information, you consent
                  to receive calls and emails from us regarding new launches,
                  exclusive offers, and promotions.
                </small>
              </div>
              <button
                type="submit"
                style={{ background: "#004dac" }}
                className=" btn w-100  text-light"
              >
                Submit
              </button>
            </form>
          </div>
          <div className="bg-white py-4 px-3 rounded-3 d-lg-none">
            <div
              className="p-3 rounded-3"
              style={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)" }}
            >
              <h2
                className="mb-2 text-center"
                style={{ fontFamily: "Metropolis-bold", fontSize: "1.4em" }}
              >
                <em>
                  <span style={{ color: "#004dac" }}>
                    BOOK A FREE TEST RIDE
                  </span>
                </em>
              </h2>
              <div
                className="mx-auto mb-3"
                style={{
                  height: "1px",
                  backgroundColor: "black",
                  width: "100%",
                }}
              ></div>
              <div>
                <p
                  className="mt-3 text-center"
                  style={{
                    fontFamily: "Metropolis-light",
                    fontSize: "0.9rem",
                    lineHeight: "1.3em",
                  }}
                >
                  <em>Experience the thrill of electric cycling!</em>
                </p>
              </div>
              <form
                className="d-flex mt-4 rounded-3 justify-content-between align-content-center flex-column"
                onSubmit={bookTestride}
              >
                <input
                  type="text"
                  className="form-control text-dark w-100 mb-3 "
                  required
                  value={name}
                  autoComplete="off"
                  style={{ background: "none" }}
                  placeholder="Name"
                  pattern="[A-Za-z\s]{2,}"
                  onChange={(e) => {
                    setName(e.target.value);
                    e.target.setCustomValidity("");
                  }}
                  onInvalid={(e) =>
                    e.target.setCustomValidity(
                      "Name should have at least 2 characters and contain only alphabets."
                    )
                  }
                />
                <input
                  type="number"
                  className="form-control text-dark w-100 mb-3"
                  required
                  value={phoneNumber}
                  onChange={(e) => {
                    const phoneNumber = e.target.value.slice(0, 12);
                    setPhoneNumber(phoneNumber);

                    if (/^[6-9]\d{9}$/.test(phoneNumber)) {
                      e.target.setCustomValidity("");
                    } else {
                      e.target.setCustomValidity(
                        "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                      );
                    }
                  }}
                  onInvalid={(e) =>
                    e.target.setCustomValidity(
                      "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                    )
                  }
                  placeholder="Phone Number"
                />
                <div
                  className="mb-2 text-muted text-center"
                  style={{ fontSize: "0.7em" }}
                >
                  <small>
                    Disclaimer: By sharing your contact information, you consent
                    to receive calls and emails from us regarding new launches,
                    exclusive offers, and promotions.
                  </small>
                </div>
                <button
                  type="submit"
                  style={{ background: "#004dac" }}
                  className=" btn w-100  text-light"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
          {/* <div
        className="position-absolute d-none d-lg-block"
        style={{ top: "73%", right: "8%" }}
      >
        <Link
          to={"/bikes"}
          className="home-cta-1 text-center text-decoration-none p-3 ps-4 pe-4 ps-lg-5 pe-lg-5"
          style={{
            fontFamily: "Metropolis-bold",
            fontSize: "1.1rem",
          }}
        >
          KNOW MORE
        </Link>
      </div>
      <div className="position-absolute w-100 doodle-pro-button-banner-mobile d-lg-none">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ flexDirection: "column" }}
        >
          <div
            className="d-flex justify-content-center"
            style={{ gap: "1em" }}
          >
            <div className="btn-know-more text-uppercase rounded-5">
              <Link
                to={"/bikes"}
                style={{ color: "inherit" }}
                className="my-2 text-decoration-none metropolis-bold"
              >
                KNOW MORE
              </Link>
            </div>
          </div>
        </div>
      </div> */}
        </div>
        <div className="d-none d-lg-block">
          <div
            className="py-5 awareness-usp-section d-flex align-items-center"
            style={{ overflow: "hidden" }}
          >
            <div className="w-100">
              <h2 className="text-center metropolis-bold mb-4 text-uppercase">
                <em>
                  Safe. Fun. <span className="text-em">Electric.</span>
                </em>
              </h2>
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: true,
                }}
                slidesPerView={1.3}
                loop={false}
                simulateTouch={true}
                slide
                speed={1000}
                modules={[Pagination, Navigation]}
                breakpoints={{
                  1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 30,
                    pagination: true,
                    simulateTouch: true,
                  },
                  1600: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    pagination: true,
                    simulateTouch: true,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="p-2">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/No+License+Required.jpg"
                      ></img>
                    </div>
                    <div className="px-2">
                      <h5 className="mb-1 metropolis-medium">
                        Speed Controlled up to 25 KM/Hr
                      </h5>
                      <small className="text-em metropolis-medium">
                        No License Required
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-2">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Safety+Comes+First_.jpg"
                      ></img>
                    </div>
                    <div className="px-2">
                      <h5 className="mb-1 metropolis-medium">Safe & Secure</h5>
                      <small className="text-em metropolis-medium">
                        Lights, Indicators, & Instant Braking System
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-2">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Accelerate+to+School+%26+Pedal+Back.jpg"
                      ></img>
                    </div>
                    <div className="px-2">
                      <h5 className="mb-1 metropolis-medium">
                        Accelerate to School & Pedal Back
                      </h5>
                      <small className="text-em metropolis-medium">
                        Up to 80 Km range on a single charge
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-2">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Powerful+36V+Battery.jpg"
                      ></img>
                    </div>
                    <div className="px-2">
                      <h5 className="mb-1 metropolis-medium">
                        Removable Battery to Charge Anywhere
                      </h5>
                      <small className="text-em metropolis-medium">
                        Go Long Distance with Powerful 36v Battery
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-2">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Smart+Tech+for+Smart+Kids.jpg"
                      ></img>
                    </div>
                    <div className="px-2">
                      <h5 className="mb-1 metropolis-medium">
                        Keeps Kids Active & Engaged
                      </h5>
                      <small className="text-em metropolis-medium">
                        Interactive riding modes & real-time stats
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-2">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Throttle+or+Pedal+Assist_.jpg"
                      ></img>
                    </div>
                    <div className="px-2">
                      <h5 className="mb-1 metropolis-medium">
                        Five Riding Modes
                      </h5>
                      <small className="text-em metropolis-medium">
                        PAS, Throttle, Walk, Cruise, & Mechanical Mode
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
        <div className="d-lg-none mb-4">
          <div
            className="pt-5 text-center awareness-usp-section"
            style={{ overflow: "hidden" }}
          >
            <div className="w-100">
              <div className="">
                <h2 className="text-center metropolis-bold mb-4 text-uppercase">
                  <em>
                    Safe. Fun. <span className="text-em">Electric.</span>
                  </em>
                </h2>
              </div>
            </div>
          </div>
          <div>
            <Swiper
              spaceBetween={10}
              centeredSlides={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: true,
              }}
              pagination={
                ({
                  clickable: true,
                },
                false)
              }
              slidesPerView={1.3}
              loop={true}
              simulateTouch={true}
              slide
              speed={1000}
              modules={[Pagination, Navigation]}
            >
              <SwiperSlide>
                <div className="p-2 pt-0">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/No+License+Required.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Speed Controlled up to 25 KM/Hr
                    </h5>
                    <small className="text-em metropolis-medium">
                      No License Required
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2 pt-0">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Safety+Comes+First_.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">Safe & Secure</h5>
                    <small className="text-em metropolis-medium">
                      Lights, Indicators, & Instant Braking System
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2 pt-0">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Accelerate+to+School+%26+Pedal+Back.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Accelerate to School & Pedal Back
                    </h5>
                    <small className="text-em metropolis-medium">
                      Up to 80 Km range on a single charge
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2 pt-0">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Powerful+36V+Battery.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Removable Battery to Charge Anywhere
                    </h5>
                    <small className="text-em metropolis-medium">
                      Go Long Distance with Powerful 36v Battery
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2 pt-0">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Smart+Tech+for+Smart+Kids.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Keeps Kids Active & Engaged
                    </h5>
                    <small className="text-em metropolis-medium">
                      Interactive riding modes & real-time stats
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2 pt-0">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/USPs/Throttle+or+Pedal+Assist_.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Five Riding Modes
                    </h5>
                    <small className="text-em metropolis-medium">
                      PAS, Throttle, Walk, Cruise, & Mechanical Mode
                    </small>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div
          className="py-5 pinned-section"
          style={{ backgroundColor: "#F5F5F5" }}
        >
          <div>
            <h2 className="text-center metropolis-bold mb-2 text-uppercase">
              <em>
                Electric. Effortless. <span className="text-em">Exciting.</span>
              </em>
            </h2>
            <p className="text-center">
              The goodness of cycling meets the power of motorbikes—designed
              <br className="d-none d-lg-block"></br>for kids who love to ride
              and parents who value safety.
            </p>
          </div>
          <div className="py-lg-4 pt-4">
            <Swiper
              spaceBetween={20}
              centeredSlides={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: true,
              }}
              slidesPerView={1.3}
              loop={true}
              simulateTouch={true}
              slide
              speed={1000}
              modules={[Navigation]}
              breakpoints={{
                1024: {
                  slidesPerView: 3.3,
                  spaceBetween: 30,
                  pagination: false,
                  loop: true,
                  simulateTouch: true,
                },
              }}
            >
              {specs.map((spec) => (
                <SwiperSlide>
                  <div>
                    <div className="mb-3">
                      <picture className="">
                        <source
                          media="(max-width:650px)"
                          srcSet={spec.mobileImage}
                        />
                        <source
                          media="(min-width:651px)"
                          srcSet={spec.desktopImage}
                        />
                        <img
                          src={spec.desktopImage}
                          className="img-fluid rounded-3"
                          style={{
                            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                          }}
                        />
                      </picture>
                    </div>
                    <div className="text-center">
                      <h5 className="mb-1 metropolis-medium">{spec.title}</h5>
                      <small className="text-em metropolis-medium">
                        {spec.desc}
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="overlap-section">
          <div>
            <video className="w-100" autoPlay loop muted playsInline>
              <source
                media="(max-width:650px)"
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/GifVideo/Kids-Mobile.mp4"
                type="video/mp4"
              />
              <source
                media="(min-width:651px)"
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/GifVideo/Kids-Desktop.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
          <div
            className="py-5 px-lg-5 px-3"
            style={{ backgroundColor: "white" }}
          >
            <div className="text-center">
              <h2 className="text-center metropolis-bold text-uppercase">
                <em>
                  Not Your Average <span className="text-em">E-Cycle</span>
                </em>
              </h2>
              <p className="mb-0">
                We’re not saying we’re the best, but we’re better than the rest!
              </p>
            </div>
            <div className="pb-4">
              <div className="row justify-content-center align-items-center">
                <div className="col-md-6 p-0">
                  <div className="d-flex justify-content-center">
                    <video className="w-100" autoPlay loop muted playsInline>
                      <source
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/TREX+Pro-6_1.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <div>
                    <h3 className="metropolis-bold text-uppercase text-center">
                      Our Premium E-Cycles<br></br>Built to{" "}
                      <span className="text-em">Rule the Roads.</span>
                    </h3>
                  </div>
                </div>
                <div className="row col-md-6 p-0">
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/battery.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          Water-Resistant<br></br>Removable Battery
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/riders.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          1 Lakh+<br></br>Happy Riders
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/countries.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          Exported To<br></br>30+ Countries
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/centres.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          12+ Experience<br></br>Centers
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/india.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          Proudly Made<br></br>in India
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/production.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          In-house Component<br></br>Production
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/service.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          72-Hour Quick<br></br>Issue Resolution
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-3">
                    <div className="border border-dark p-1 w-100 rounded-3">
                      <div className="mb-2 d-flex justify-content-center">
                        <img
                          className="img-fluid"
                          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/dealer.png"
                        ></img>
                      </div>
                      <div
                        className="text-center"
                        style={{ fontSize: "0.85em" }}
                      >
                        <small>
                          650+ Dealerships<br></br>Across India
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="pt-3 d-flex justify-content-center">
                    <Link
                      to={"/bikes"}
                      className="btn btn-dark rounded-5 text-center text-decoration-none px-4 py-2"
                      style={{
                        fontFamily: "Metropolis-bold",
                        fontSize: "1rem",
                      }}
                    >
                      KNOW MORE
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <picture className="main-banner-img">
              <source
                media="(max-width:650px)"
                srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Breaker/Mobile+breaker.jpg"
              />
              <source
                media="(min-width:651px)"
                srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Breaker/Web+breaker.jpg"
              />
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Breaker/Web+breaker.jpg"
                alt="Banner1"
                className="d-block w-100"
              />
            </picture>
          </div>
          <div className="py-5" style={{ backgroundColor: "white" }}>
            <h2 className="text-center metropolis-bold mb-4 text-uppercase">
              <em>
                They're <span className="text-em">Loving It!</span>
              </em>
            </h2>
            <div className="container">
              <Swiper
                spaceBetween={15}
                slidesPerView={1.2}
                initialSlide={2}
                centeredSlides={false}
                loop={true}
                slide
                breakpoints={{
                  1024: {
                    initialSlide: 4,
                    allowTouchMove: false,
                    slidesPerView: 3,
                    spaceBetween: 20,
                    loop: false,
                    slide: false,
                    noSwiping: true,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="p-3 rounded-3 bg-light">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/rajesh.jpg"
                      ></img>
                    </div>
                    <div
                      className="text-center p-2"
                      style={{ fontSize: "0.8em" }}
                    >
                      <small>
                        The Doodle is just amazing for city rides! It’s small
                        but strong, and I can easily ride through traffic. The
                        battery lasts a long time because my routes are small,
                        so I don’t have to charge it every day. It's foldable so
                        I can store it anywhere.
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-3 rounded-3 bg-light">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/priya.jpg"
                      ></img>
                    </div>
                    <div
                      className="text-center p-2"
                      style={{ fontSize: "0.8em" }}
                      // style={{ height: "190px" }}
                    >
                      <small>
                        I’ve been using the X2 for a few months, and I love it!
                        The motor is strong, and the ride feels smooth, even
                        when I'm on bad roads. I was unsure about getting an
                        e-cycle, but this one is truly amazing. It’s perfect for
                        city roads and off-road.
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="p-3 rounded-3 bg-light">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/arjun.jpg"
                      ></img>
                    </div>
                    <div
                      className="text-center p-2"
                      style={{ fontSize: "0.8em" }}
                      // style={{ height: "190px" }}
                    >
                      <small>
                        The X1 is fast, light, and looks great, and fits my
                        budget. The pedal assist helps me take long trips. It’s
                        so smooth, and I love how quickly I can speed up. I
                        mainly use it during the weekends, and my friend is also
                        thinking of getting one after test-riding mine.
                      </small>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div className="py-5" style={{ backgroundColor: "#F5F5F5" }}>
            <h2 className="text-center metropolis-bold mb-4 mb-lg-5 text-uppercase">
              <em>
                E-Cycles <span className="text-em">Caught Posing</span>
              </em>
            </h2>
            <div className="">
              <Swiper
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                spaceBetween={20}
                slidesPerView={1.3}
                initialSlide={0}
                centeredSlides={true}
                loop={true}
                simulateTouch={true}
                slide
                speed={1000}
                modules={[Pagination, Navigation]}
                pagination={false}
                breakpoints={{
                  1024: {
                    slidesPerView: 4.5,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    pagination: true,
                    simulateTouch: true,
                  },
                  1600: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    pagination: true,
                    simulateTouch: true,
                  },
                }}
              >
                {celebs.map((celeb, index) => (
                  <SwiperSlide>
                    <div className="p-3 rounded-3 bg-white">
                      <div className="mb-3">
                        <img
                          className="img-fluid rounded-3"
                          src={celeb.image}
                        ></img>
                      </div>
                      <div className="text-center" style={{ height: "80px" }}>
                        <p className="metropolis-medium fw-bold mb-1">
                          {celeb.name}
                        </p>
                        <small>{celeb.designation}</small>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KidsAwarenessScreen;
